import moment from 'moment-timezone';

const convertTimeToGMT = value => (`(GMT${moment().tz(value).format('Z').split(':')[0]})`);

export default convertTimeToGMT;
